<template>
  <div class="c-table" ref="shutdownlisttable">
    <el-table class="common-el-table-styles" ref="table" v-loading="loading" :data="data" :height="height" border stripe>
      <template slot="empty">
        <no-data />
      </template>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-detail', scope.row)">计划详情</el-button>
            <el-button v-if="scope.row.fail" type="text" size="small" @click="$emit('on-retry', scope.row)">重试</el-button>
            <el-button v-if="scope.row.allowRestart === 1" type="text" size="small" @click="restartRule(scope.row)"> 一键重启 </el-button>
          </div>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'opType'">{{ scope.row[col.key] | opType }}</span>
          <span v-else-if="col.key === 'imageNames'">{{ scope.row[col.key] || '——' }}</span>
          <span v-else-if="col.key === 'gameNames'">{{ scope.row[col.key] || (scope.row.taskType === 1 ? '全部' : '——') }}</span>
          <span v-else-if="col.key === 'taskType'">{{ scope.row[col.key] | taskType }}</span>
          <span v-else-if="col.key === 'account'">
            {{ scope.row.accountNames || '全账号' }}{{ scope.row.mediaNames ? '（' + scope.row.mediaNames + '）' : '' }}
          </span>
          <span v-else-if="col.key === 'funcObject'"
            >{{ scope.row.adStatus | adStatus }}；新建时间{{ scope.row.adTimeRange | adTimeRange }}计划</span
          >
          <span v-else-if="col.key === 'result' && scope.row.total">
            操作计划{{ scope.row.total }}条，成功{{ scope.row.success }}条，失败
            <p style="color: red; display: inline-block">{{ scope.row.fail }}</p>
            条
          </span>
          <span v-else-if="col.key === 'taskStatus'">{{ scope.row[col.key] | taskStatus }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout } from '@/common/js/utils'
export default {
  name: 'listtable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  filters: {
    opType(val) {
      let type
      switch (val) {
        case 0:
          type = '暂停计划'
          break
        case -1:
          type = '删除计划'
          break
        case 1:
          type = '启动计划'
          break
        case 2:
          type = '暂停素材'
          break
        case 3:
          type = '删除素材'
          break
        default:
          type = '未知'
          break
      }
      return type
    },
    taskStatus(val) {
      let type
      switch (val) {
        case -1:
          type = '失败'
          break
        case 0:
          type = '未开始'
          break
        case 1:
          type = '进行中'
          break
        case 2:
          type = '已完成'
          break
        default:
          type = '未知'
          break
      }
      return type
    },
    adStatus(val) {
      let type
      switch (val) {
        case 0:
          type = '暂停中'
          break
        case 1:
          type = '启用中'
          break
        case 2:
          type = '启用中/暂停中'
          break
        default:
          type = '未知'
          break
      }
      return type
    },
    adTimeRange(val) {
      let type
      switch (val) {
        case 1:
          type = '1个月内'
          break
        case 2:
          type = '3个月内'
          break
        case 3:
          type = '6个月内'
          break
        default:
          type = '未知'
          break
      }
      return type
    },
    taskType(val) {
      let type
      switch (val) {
        case 0:
          type = '一键素材关停'
          break
        case 1:
          type = '一键计划关停'
          break
        default:
          type = '未知'
          break
      }
      return type
    }
  },
  methods: {
    restartRule(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '确定要对已经关闭的全部进行开启吗？',
        onOk: () => {
          this.$emit('on-restart', row)
        }
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout()
    })
  }
}
</script>
